import * as reportTypes from '../constants';
import AccountBalanceHistory from './pages/accounting/account-balance-history';
import { BillingReports } from './pages/exports/billing-reports';
import Customers from './pages/exports/customers';
import ExportsShippedItems from './pages/exports/exports-shipped-items';
import Orders from './pages/exports/orders';
import ProductAliases from './pages/exports/product-aliases';
import ShippedOrders from './pages/exports/shipped-orders';
import BarcodeScanActionReport from './pages/hotkey-and-barcode/barcode-scan-action';
import BarcodeScanQuickReference from './pages/hotkey-and-barcode/barcode-scan-quick-reference/';
import HotkeyReferenceSheet from './pages/hotkey-and-barcode/hotkey-reference-sheet';
import InventoryAuditReport from './pages/inventory/inventory-audit-report';
import InventoryLowStockReport from './pages/inventory/inventory-low-stock-report';
import InventoryOutOfStockShipments from './pages/inventory/inventory-out-of-stock-shipments';
import InventoryStatusReport from './pages/inventory/inventory-status-report';
import BuyerComments from './pages/orders/buyer-comments';
import CountryComparison from './pages/orders/country-comparison';
import OrderDetail from './pages/orders/order-detail';
import { OrdersByLot } from './pages/orders/orders-by-lot';
import ItemDemandSummary from './pages/products/item-demand-summary';
import ProductSales from './pages/products/product-sales';
import ReturnedProducts from './pages/products/returned-products';
import BatchDetail from './pages/shipments/batch-detail';
import ShipmentCountByUser from './pages/shipments/shipment-count-by-user';
import ShipmentsShippedItems from './pages/shipments/shipments-shipped-items';
import ShippingCost from './pages/shipments/shipping-cost';
import ShippingManifest from './pages/shipments/shipping-manifest';

export const ReportPages = {
  [reportTypes.ORDER_DETAIL]: OrderDetail,
  [reportTypes.COUNTRY_COMPARISON]: CountryComparison,
  [reportTypes.BUYER_COMMENTS]: BuyerComments,
  [reportTypes.ORDERS_BY_LOT]: OrdersByLot,
  [reportTypes.ITEM_DEMAND_SUMMARY]: ItemDemandSummary,
  [reportTypes.PRODUCT_SALES]: ProductSales,
  [reportTypes.RETURNED_PRODUCTS]: ReturnedProducts,
  [reportTypes.SHIPMENT_COUNT_BY_USER]: ShipmentCountByUser,
  [reportTypes.SHIPMENTS_SHIPPED_ITEMS]: ShipmentsShippedItems,
  [reportTypes.SHIPPING_COST]: ShippingCost,
  [reportTypes.SHIPPING_MANIFEST]: ShippingManifest,
  [reportTypes.BATCH_DETAIL]: BatchDetail,
  [reportTypes.ACCOUNT_BALANCE_HISTORY]: AccountBalanceHistory,
  [reportTypes.INVENTORY_LOW_STOCK_REPORT]: InventoryLowStockReport,
  [reportTypes.INVENTORY_AUDIT_REPORT]: InventoryAuditReport,
  [reportTypes.INVENTORY_OUT_OF_STOCK_SHIPMENTS]: InventoryOutOfStockShipments,
  [reportTypes.INVENTORY_STATUS_REPORT]: InventoryStatusReport,
  [reportTypes.BILLING_REPORTS]: BillingReports,
  [reportTypes.RAW_EXPORTS_CUSTOMERS]: Customers,
  [reportTypes.RAW_EXPORTS_ORDERS]: Orders,
  [reportTypes.RAW_EXPORTS_SHIPPED_ORDERS]: ShippedOrders,
  [reportTypes.RAW_EXPORTS_SHIPPED_ITEMS]: ExportsShippedItems,
  [reportTypes.RAW_EXPORTS_PRODUCT_ALIASES]: ProductAliases,
  [reportTypes.HOTKEYS_REFERENCE_REPORT]: HotkeyReferenceSheet,
  [reportTypes.BARCODE_SCAN_ACTION_REPORT]: BarcodeScanActionReport,
  [reportTypes.BARCODE_SCAN_QUICK_REFERENCE_REPORT]: BarcodeScanQuickReference,
};
